import { useTranslations } from '@vocab/react';
import { Dialog, Inline, Button, Text } from 'braid-design-system';
import { type FC, useId } from 'react';

import { ConnectionPlugIllustration } from 'src/libs/Illustrations';

import translations from './.vocab';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const PurchaseReferenceCheckErrorDialog: FC<Props> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslations(translations);
  const id = useId();
  return (
    <Dialog
      id={id}
      closeLabel={t('Close')}
      onClose={onClose}
      open={open}
      illustration={<ConnectionPlugIllustration />}
      title={t("We can't offer the reference check add-on right now")}
      description={
        <Text>
          {t(
            'If you are trying to purchase more reference checks, please refresh the page or try again later.',
          )}
        </Text>
      }
      width="small"
    >
      <Inline space="small" align="center">
        <Button onClick={onClose} variant="solid" tone="brandAccent">
          {t('Close')}
        </Button>
      </Inline>
    </Dialog>
  );
};
